import { JsonPatchOperationModel } from '@fleet-beat/api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function objectsDiffToPayload<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any>,
  K extends keyof T,
  V extends string | number | boolean,
>(obj1: T, obj2: T, basePath: string = ''): JsonPatchOperationModel[] {
  let putPayload: JsonPatchOperationModel[] = [];
  let perimeterChanged: boolean = false;

  (Object.keys(obj1) as K[]).forEach((key: K) => {
    if (key === 'perimeter' && typeof obj1[key] === 'object') {
      const perimeterDiff = perimeterObjectsDiffToPayload(obj1[key], obj2[key], basePath);
      if (perimeterDiff.length > 0) {
        perimeterChanged = true;
      }
    } else {
      if (typeof obj1[key] !== 'object') {
        if (obj1[key] !== obj2[key]) {
          if (Boolean(obj1[key]) === false && Boolean(obj2[key]) === false) return;
          const value: V = obj1[key] as V;
          putPayload.push({ op: 'add', path: `${basePath}/${String(key)}`, value: value });
        }
      } else {
        if (!obj2[key]) obj2[key] = {} as T[K];
        if (!obj1[key]) obj1[key] = {} as T[K];
        putPayload = putPayload.concat(objectsDiffToPayload(obj1[key] as T, obj2[key] as T, `/${key as string}`));
      }
    }
  });

  if (perimeterChanged) {
    putPayload.push({ op: 'replace', path: `${basePath}/perimeter`, value: obj1['perimeter'] });
  }

  return putPayload;
}

function perimeterObjectsDiffToPayload<T, K extends keyof T, V extends string | number | boolean>(
  obj1: T,
  obj2: T,
  basePath: string,
): JsonPatchOperationModel[] {
  const perimeterPayload: JsonPatchOperationModel[] = [];

  (Object.keys(obj1) as K[]).forEach((key: K) => {
    if (obj1[key] !== obj2[key]) {
      const value: V = obj1[key] as V;
      perimeterPayload.push({ op: 'replace', path: `${basePath}/${String(key)}`, value: value });
    }
  });

  return perimeterPayload;
}
